import ModalBox from './modal-box';

export default ModalBox;
